import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingRoutingModule } from './setting-routing.module';
import { OrderCatogoryCardModule } from 'src/app/components/modules/order-catogory-card/order-catogory-card.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeNameModule } from 'src/app/dialog/change-name/change-name.module';
import { ChangePasswordModule } from 'src/app/dialog/change-password/change-password.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarMessageModule } from 'src/app/components/snackbar-message/snackbar-message.module';
import { ImageModule } from 'src/app/components/image/image.module';
import { SettingHomeComponent } from './components/setting-home/setting-home.component';
import { AvatarModule } from 'src/app/components/avatar/avatar.module';
import { OrderCategoryGroupModule } from 'src/app/components/order-category-group/order-category-group.module';
import { AddEmailModule } from 'src/app/dialog/add-email/add-email.module';
// import { NewImageCropperModule } from 'src/app/dialog/new-image-cropper/new-image-cropper.module';


@NgModule({
  declarations: [
    SettingHomeComponent
  ],
  imports: [
    CommonModule,
    OrderCatogoryCardModule,
    MatDividerModule,
    ChangeNameModule,
    AddEmailModule,
    MatSnackBarModule,
    SnackbarMessageModule,
    ChangePasswordModule,
    MatButtonModule,
    AvatarModule,
    MatIconModule,
    MatFormFieldModule,
    ImageModule,
    SnackbarMessageModule,
    MatSelectModule,
    TranslateModule,
    SettingRoutingModule,
    OrderCategoryGroupModule
  ]
})
export class SettingModule { }
